import { createSlice } from '@reduxjs/toolkit';
import { AuthState } from '@/types/auth.types.ts';
import { projectData, reduxSlice } from '@/constants/constants';

const initialState: AuthState = {
  jwt: localStorage.getItem(projectData.tokenName) ?? null,
  isLoading: false,
  error: null,
  isAuthenticated: !!localStorage.getItem(projectData.tokenName),
};

const authSlice = createSlice({
  name: reduxSlice.auth,
  initialState,
  reducers: {
    login: (state, { payload }) => {
      localStorage.setItem(projectData.tokenName, payload.jwt);
      state.jwt = payload.jwt;
      state.isLoading = false;
      state.error = null;
      state.isAuthenticated = true;
    },
    logout: (state) => {
      localStorage.removeItem(projectData.tokenName);
      state.jwt = null;
      state.isAuthenticated = false;
    },
  },
});

export const { logout, login } = authSlice.actions;
export default authSlice.reducer;
